module.exports = "/_next/static/images/CentralizeAndSimplify@2x-201bbfb45b9197c218127d9d51307f0d.png";